import { useNavigate } from "react-router-dom";
import {
  Toolbar as MuiToolbar,
  Tooltip as MuiTooltip,
  IconButton as MuiIconButton,
  Typography as MuiTypography,
} from "@mui/material";
import {
  ChevronLeft as MuiChevronLeftIcon,
  ArrowBack as MuiArrowBackIcon,
} from "@mui/icons-material";

const PageTitle = (props) => {
  const navigate = useNavigate();

  const {
    pageTitle,
    hasBackButton,
    hasDrawer,
    openDrawer,
    toggleDrawer,
    drawerIconTooltip,
    backButtonTooltip,
    backActionCB,
  } = props;

  return (
    <MuiToolbar
      sx={{
        width: "100%",
        minHeight: "30px",
        paddingTop: "24px",
        paddingLeft: hasDrawer ? "0px" : "30px",

        "& .MuiIconButton-root": {
          marginRight: "12px",
        },

        "& .MuiTypography-h5": {
          fontWeight: "200",
        },
      }}
    >
      {hasDrawer && (
        <MuiTooltip
          title={drawerIconTooltip ? drawerIconTooltip : "Toggle Drawer"}
          placement="top"
          arrow
        >
          <MuiIconButton onClick={toggleDrawer} size="small">
            <MuiChevronLeftIcon
              sx={
                !openDrawer && {
                  transform: "rotate(180deg)",
                }
              }
              fontSize="small"
            />
          </MuiIconButton>
        </MuiTooltip>
      )}
      {hasBackButton && (
        <MuiTooltip
          title={
            backButtonTooltip ? backButtonTooltip : "Back to previous page"
          }
          placement="top"
          arrow
        >
          <MuiIconButton
            onClick={() => {
              if (backActionCB && backActionCB instanceof Function) {
                backActionCB();
              }

              navigate(-1);
            }}
            size="small"
          >
            <MuiArrowBackIcon fontSize="small" />
          </MuiIconButton>
        </MuiTooltip>
      )}
      <MuiTypography variant="h1" fontWeight={500} noWrap>
        {pageTitle}
      </MuiTypography>
    </MuiToolbar>
  );
};

export default PageTitle;
